export default "__VITE_ASSET__DFME29zs__"